module.exports = "## State of the art PNG compression\r\n\r\nPNG is another image format that is widely used. Compared to JPEG, PNG uses a lossless (reversible) compression algorithm. This means it stores extra data to be able to reverse the image to its original quality. Such extra data, however, bloat the file size.\r\n\r\nOur PNG Compressor applies a lossy compression algorithm and removes extra metadata. The result is a drastically reduced PNG files size without losing image quality."


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoCompress/photo-compress-section-three.md
// module id = 1160
// module chunks = 0